import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../stores/useStores';
import { formatTime } from '../../../utils/time';
import classes from '../DailyMissions.module.scss';

export type DailyMissionTimerProps = {
  className?: string;
  dataTestId?: string;
};

export const DailyMissionTimer = observer(({ className, dataTestId }: DailyMissionTimerProps) => {
  const { t } = useTranslation();
  const { dailyMissionsStore, coinTypeStore } = useStores();
  const rawTimer = dailyMissionsStore.getRawTimer(coinTypeStore.coinType);
  if (!rawTimer) {
    return null;
  }
  const timer = formatTime(rawTimer, 's', t);
  return (
    <div className={classNames(classes.timer, className)} data-testid={dataTestId}>
      {timer}
    </div>
  );
});
